<template>
  <div
    v-if="typeof localValue === 'boolean'"
    :class="$style.base"
  >
    <BaseHeading
      size="l"
      :mb="2"
    >
      {{ $t('admin.assistant.online_booking.heading') }}
    </BaseHeading>
    <div :class="$style.form">
      <RadioCards
        v-model="localValue"
        :options="[
          {
            label: $t('admin.assistant.online_booking.option_1.heading'),
            image: `/img/salonized-assistant/${getImageLanguage}/booking-request.png`,
            value: true
          },
          {
            label: $t('admin.assistant.online_booking.option_2.heading'),
            image: `/img/salonized-assistant/${getImageLanguage}/booking-online.png`,
            value: false
          }
        ]"
      />
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
import getImageLanguage from '../imageLanguage';
import RadioCards from './_shared/RadioCards.vue';

const emit = defineEmits(['update:modelValue']);

const props = defineProps<{
  modelValue?: boolean | null;
}>();

const localValue = ref(props.modelValue);

watch(
  localValue,
  () => {
    emit('update:modelValue', localValue.value);
  },
  {
    deep: true,
  },
);
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  flex-direction: column;
  max-height: 100%;
}

.form {
  flex: 1;
  max-height: 100%;
}
</style>
